import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

import "swiper/css";
import "swiper/css/pagination";

import "@dmuy/datepicker/dist/duDatepicker.css";
import "@src/ui/datepicker.css";

import "@src/ui/index.css";

import "./initial";

import { createContext, IContext } from "../context";
import { localeCreatorInput } from "./locale";

import { setupGlobal } from "./setupGlobal";
import { setupUrlHash } from "./hash";

/* elements */
import "./elements/UnitStatus";
import "./elements/Address";
import "./elements/DropdownSort";
import "./elements/NoProperties";
import { setupPopup } from "./elements/Popup";
import { setupLoading } from "./elements/Loading";
import { setupAutocomplete } from "./elements/Autocomplete";
import { setupSelectSort } from "./elements/SelectSort";

/* components */
import "./components/Breadcrumb";
import "./components/BreadcrumbSmaller";
import "./components/ContactTop";
import "./components/ContactBottom";
import "./components/Footer";
import "./components/HorizontalCard";
import "./components/PropertySearch";
import "./components/Text";
import "./components/Maisoku";
import "./components/CompanyProfile";
import "./components/UnitCard";
import "./components/Table";
import { setupSwiper } from "./components/Swiper";
import { setupFilter } from "./components/Filter";
import { setupSearchCards } from "./components/SearchCards";
import { setupShowcase } from "./components/Showcase";
import { setupInformation } from "./components/Information";
import { setupGallery } from "./components/Gallery";
import { setupProperty } from "./components/Property";
import { setupQA } from "./components/QA";
import { setupHeader } from "./components/Header";
import { setupRooms } from "./components/Rooms";
import { setupNearby } from "./components/Nearby";
import { setupFeaturedProperties } from "./components/FeaturedProperties";
import { SearchPopup } from "./components/SearchPopup";
import { setupSearchResult } from "./components/SearchResult";
import { setupVR } from "./components/VR";
import { setupEnquiryForm } from "./components/EnquiryForm";
import { setupBookVisit } from "./components/BookVisit";
import { setupThankYou } from "./components/ThankYou";
import { setupShortList } from "./components/ShortList";
import { setupCompanyInformation } from "./components/CompanyInformation";
import { setupNews } from "./components/News";
import { setupCorporate } from "./components/Corporate";
import { setupMapFilter } from "./components/MapFilter";
import { setupMapArea } from "./components/MapArea";
import { setupInitialCost } from "./components/InitialCost";

const APP_NAME = "containers";

function setupComponents(context: IContext) {
  setupSwiper();
  setupFilter(context);
  SearchPopup(context);
  setupLoading(context);
  setupAutocomplete(context);
  setupSelectSort();
  setupSearchCards();
  setupGallery();
  setupProperty();
  setupQA();
  setupShowcase();
  setupInformation();
  setupHeader();
  setupRooms(context);
  setupNearby();
  setupFeaturedProperties(context);
  setupPopup();
  setupSearchResult(context);
  setupVR(context);
  setupEnquiryForm(context);
  setupBookVisit(context);
  setupThankYou();
  setupShortList(context);
  setupCompanyInformation();
  setupNews();
  setupCorporate(context);
  setupMapFilter(context);
  setupMapArea();
  setupInitialCost(context);
}

function main() {
  const context = createContext(APP_NAME, localeCreatorInput());

  try {
    setupGlobal(context);
    setupComponents(context);
    setupUrlHash();
  } catch (err) {
    if (err instanceof Error) {
      context.errorNotifier.notify(err);
    } else {
      context.errorNotifier.notify(String(err));
    }

    throw err;
  }
}

main();
